import React, { useState, useEffect } from 'react';

const MotionMarquee = ({ children, speed = 80, ...props }) => {
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);
  
  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    setPrefersReducedMotion(mediaQuery.matches);
    
    const handleChange = (e) => setPrefersReducedMotion(e.matches);
    mediaQuery.addEventListener('change', handleChange);
    
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  if (prefersReducedMotion) {
    return (
      <div className="flex items-center justify-center gap-8 flex-wrap">
        {children}
      </div>
    );
  }

  // Convert speed to duration (higher speed = faster = shorter duration)
  // Speed 80 = ~15s, Speed 40 = ~30s
  const duration = (20 * 80) / speed;

  return (
    <div 
      className="overflow-hidden whitespace-nowrap"
      {...props}
    >
      <div
        className="inline-flex items-center marquee-content"
        style={{
          animationDuration: `${duration}s`
        }}
      >
        {/* Duplicate content multiple times for seamless loop */}
        <div className="inline-flex items-center marquee-item">
          {children}
        </div>
        <div className="inline-flex items-center marquee-item" aria-hidden="true">
          {children}
        </div>
        <div className="inline-flex items-center marquee-item" aria-hidden="true">
          {children}
        </div>
      </div>
    </div>
  );
};

export default MotionMarquee;
